import React, { Component } from "react";

import ErrorImage from "../../Assets/Images/error404.jpg";

class NotFound extends Component {
  render() {
    return (
      <div
        style={{
          width: "100%",
          minHeight: "90vh",
          backgroundImage: `url(${ErrorImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
    );
  }
}

export default NotFound;
